import {
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotActive2613wuivyis0b as InternalReactiveNotActive,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  ReactiveStatel8ixobo86msn as ReactiveState,
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
} from '../core/ReactiveState.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  valueSet3cf2hvvu95f3 as valueSet,
  set3ct43wkzm94lj as set,
  lens2e2i845xidu26 as lens_1,
  lens26es9640ifscs as lens_2,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
  get_state389x218zizu8a as get_state,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  Listenable3m4zqvjcbvczy as Listenable,
} from '../core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { awaitOnce3bs0u39jtmrli as awaitOnce } from '../context/DependencyChangeListener.mjs';
import {
  BaseReactive302n39o7i5yop as BaseReactive,
  BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue,
} from '../core/abstracts.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SetLensClass;
function SetLens() {
  if (SetLensClass === VOID) {
    class $ extends Lens() {
      constructor(source, get, set) {
        return new.target.new_com_lightningkite_reactive_lensing_SetLens_rp2o22_k$(source, get, set);
      }
      static new_com_lightningkite_reactive_lensing_SetLens_rp2o22_k$(source, get, set) {
        var $this = this.new_com_lightningkite_reactive_lensing_Lens_wq5tr4_k$(source, get);
        $this.set_1 = set;
        return $this;
      }
      *set_revjhg_k$(value, $completion) {
        var transformed = this.set_1(value);
        this.set_state_hpk5hw_k$(_ReactiveState___init__impl__fvdp9b(this.get_1(transformed)));
        yield* this.source_1.set_revjhg_k$(transformed, $completion);
        return Unit_instance;
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, 'SetLens', VOID, VOID, [MutableReactive()], [1]);
    SetLensClass = $;
  }
  return SetLensClass;
}
var ModifyLensClass;
function ModifyLens() {
  if (ModifyLensClass === VOID) {
    class $ extends Lens() {
      constructor(source, get, modify) {
        return new.target.new_com_lightningkite_reactive_lensing_ModifyLens_a6lpxe_k$(source, get, modify);
      }
      static new_com_lightningkite_reactive_lensing_ModifyLens_a6lpxe_k$(source, get, modify) {
        var $this = this.new_com_lightningkite_reactive_lensing_Lens_wq5tr4_k$(source, get);
        $this.modify_1 = modify;
        return $this;
      }
      *set_revjhg_k$(value, $completion) {
        var transformed = this.modify_1(yield* awaitOnce(this.source_1, $completion), value);
        this.set_state_hpk5hw_k$(_ReactiveState___init__impl__fvdp9b(this.get_1(transformed)));
        yield* this.source_1.set_revjhg_k$(transformed, $completion);
        return Unit_instance;
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, 'ModifyLens', VOID, VOID, [MutableReactive()], [1]);
    ModifyLensClass = $;
  }
  return ModifyLensClass;
}
var LensClass;
function Lens() {
  if (LensClass === VOID) {
    class $ extends BaseReactive() {
      constructor(source, get) {
        return new.target.new_com_lightningkite_reactive_lensing_Lens_wq5tr4_k$(source, get);
      }
      static new_com_lightningkite_reactive_lensing_Lens_wq5tr4_k$(source, get) {
        var $this = this.new_com_lightningkite_reactive_core_BaseReactive_2kvjp3_k$();
        $this.source_1 = source;
        $this.get_1 = get;
        $this.myListen_1 = null;
        return $this;
      }
      set_state_hpk5hw_k$(value) {
        super.set_state_wnfcx0_k$(value);
      }
      set_state_wnfcx0_k$(value) {
        return this.set_state_hpk5hw_k$(value);
      }
      get_state_wc71ny_k$() {
        if (this.myListen_1 == null) {
          var tmp0 = this.source_1.get_state_wc71uu_k$();
          var tmp2 = this.get_1;
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.map' call
            var tmp;
            var tmp_0;
            var tmp_1 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            if (tmp_1 instanceof InternalReactiveNotReady()) {
              tmp_0 = true;
            } else {
              var tmp_2 = _ReactiveState___get_raw__impl__92ipya(tmp0);
              tmp_0 = tmp_2 instanceof InternalReactiveNotActive();
            }
            if (tmp_0) {
              tmp = true;
            } else {
              var tmp_3 = _ReactiveState___get_raw__impl__92ipya(tmp0);
              tmp = tmp_3 instanceof InternalReactiveThrownException();
            }
            if (tmp) {
              tmp$ret$0 = new (ReactiveState())(tmp0) instanceof ReactiveState() ? tmp0 : THROW_CCE();
              break $l$block_1;
            }
            var tmp_4 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            if (tmp_4 instanceof InternalReactiveWrapper())
              try {
                tmp$ret$0 = _ReactiveState___init__impl__fvdp9b(tmp2(_ReactiveState___get_raw__impl__92ipya(tmp0).other_1));
                break $l$block_1;
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  tmp$ret$0 = Companion_getInstance().exception_iibuh2_k$(e);
                  break $l$block_1;
                } else {
                  throw $p;
                }
              }
            var tmp_5;
            try {
              tmp_5 = _ReactiveState___init__impl__fvdp9b(tmp2(_ReactiveState___get_raw__impl__92ipya(tmp0)));
            } catch ($p_0) {
              var tmp_6;
              if ($p_0 instanceof Exception()) {
                var e_0 = $p_0;
                tmp_6 = Companion_getInstance().exception_iibuh2_k$(e_0);
              } else {
                throw $p_0;
              }
              tmp_5 = tmp_6;
            }
            tmp$ret$0 = tmp_5;
          }
          super.set_state_wnfcx0_k$(tmp$ret$0);
        }
        return super.get_state_wc71uu_k$();
      }
      get_state_wc71uu_k$() {
        return this.get_state_wc71ny_k$();
      }
      activate_yijg9v_k$() {
        super.activate_yijg9v_k$();
        var tmp = this;
        tmp.myListen_1 = this.source_1.addListener_6y9mct_k$(() => {
          var tmp0 = this.source_1.get_state_wc71uu_k$();
          var tmp2 = this.get_1;
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.map' call
            var tmp;
            var tmp_0;
            var tmp_1 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            if (tmp_1 instanceof InternalReactiveNotReady()) {
              tmp_0 = true;
            } else {
              var tmp_2 = _ReactiveState___get_raw__impl__92ipya(tmp0);
              tmp_0 = tmp_2 instanceof InternalReactiveNotActive();
            }
            if (tmp_0) {
              tmp = true;
            } else {
              var tmp_3 = _ReactiveState___get_raw__impl__92ipya(tmp0);
              tmp = tmp_3 instanceof InternalReactiveThrownException();
            }
            if (tmp) {
              tmp$ret$0 = new (ReactiveState())(tmp0) instanceof ReactiveState() ? tmp0 : THROW_CCE();
              break $l$block_1;
            }
            var tmp_4 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            if (tmp_4 instanceof InternalReactiveWrapper())
              try {
                tmp$ret$0 = _ReactiveState___init__impl__fvdp9b(tmp2(_ReactiveState___get_raw__impl__92ipya(tmp0).other_1));
                break $l$block_1;
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  tmp$ret$0 = Companion_getInstance().exception_iibuh2_k$(e);
                  break $l$block_1;
                } else {
                  throw $p;
                }
              }
            var tmp_5;
            try {
              tmp_5 = _ReactiveState___init__impl__fvdp9b(tmp2(_ReactiveState___get_raw__impl__92ipya(tmp0)));
            } catch ($p_0) {
              var tmp_6;
              if ($p_0 instanceof Exception()) {
                var e_0 = $p_0;
                tmp_6 = Companion_getInstance().exception_iibuh2_k$(e_0);
              } else {
                throw $p_0;
              }
              tmp_5 = tmp_6;
            }
            tmp$ret$0 = tmp_5;
          }
          super.set_state_wnfcx0_k$(tmp$ret$0);
          return Unit_instance;
        });
        var tmp0 = this.source_1.get_state_wc71uu_k$();
        var tmp2 = this.get_1;
        var tmp$ret$1;
        $l$block_4: {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.map' call
          var tmp_0;
          var tmp_1;
          var tmp_2 = _ReactiveState___get_raw__impl__92ipya(tmp0);
          if (tmp_2 instanceof InternalReactiveNotReady()) {
            tmp_1 = true;
          } else {
            var tmp_3 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            tmp_1 = tmp_3 instanceof InternalReactiveNotActive();
          }
          if (tmp_1) {
            tmp_0 = true;
          } else {
            var tmp_4 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            tmp_0 = tmp_4 instanceof InternalReactiveThrownException();
          }
          if (tmp_0) {
            tmp$ret$1 = new (ReactiveState())(tmp0) instanceof ReactiveState() ? tmp0 : THROW_CCE();
            break $l$block_4;
          }
          var tmp_5 = _ReactiveState___get_raw__impl__92ipya(tmp0);
          if (tmp_5 instanceof InternalReactiveWrapper())
            try {
              tmp$ret$1 = _ReactiveState___init__impl__fvdp9b(tmp2(_ReactiveState___get_raw__impl__92ipya(tmp0).other_1));
              break $l$block_4;
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                tmp$ret$1 = Companion_getInstance().exception_iibuh2_k$(e);
                break $l$block_4;
              } else {
                throw $p;
              }
            }
          var tmp_6;
          try {
            tmp_6 = _ReactiveState___init__impl__fvdp9b(tmp2(_ReactiveState___get_raw__impl__92ipya(tmp0)));
          } catch ($p_0) {
            var tmp_7;
            if ($p_0 instanceof Exception()) {
              var e_0 = $p_0;
              tmp_7 = Companion_getInstance().exception_iibuh2_k$(e_0);
            } else {
              throw $p_0;
            }
            tmp_6 = tmp_7;
          }
          tmp$ret$1 = tmp_6;
        }
        super.set_state_wnfcx0_k$(tmp$ret$1);
      }
      deactivate_pmdz1g_k$() {
        super.deactivate_pmdz1g_k$();
        var tmp0_safe_receiver = this.myListen_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.myListen_1 = null;
      }
    }
    initMetadataForClass($, 'Lens');
    LensClass = $;
  }
  return LensClass;
}
var SetValueLensClass;
function SetValueLens() {
  if (SetValueLensClass === VOID) {
    class $ extends ValueLens() {
      constructor(source, get, set) {
        return new.target.new_com_lightningkite_reactive_lensing_SetValueLens_lhprjj_k$(source, get, set);
      }
      static new_com_lightningkite_reactive_lensing_SetValueLens_lhprjj_k$(source, get, set) {
        var $this = this.new_com_lightningkite_reactive_lensing_ValueLens_6349z_k$(source, get);
        $this.set_1 = set;
        return $this;
      }
      set_value_v1vabv_k$(value) {
        var transformed = this.set_1(value);
        super.set_value_jb4831_k$(this.get_1(transformed));
        this.source_1.set_value_v1vabv_k$(transformed);
      }
      set_value_jb4831_k$(value) {
        return this.set_value_v1vabv_k$(value);
      }
      get_value_j01efc_k$() {
        return super.get_value_j01efc_k$();
      }
    }
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).set_revjhg_k$ = set;
    protoOf($).lens_drj4fu_k$ = lens_1;
    protoOf($).lens_u4wb4z_k$ = lens_2;
    initMetadataForClass($, 'SetValueLens', VOID, VOID, [MutableReactiveValue()], [1]);
    SetValueLensClass = $;
  }
  return SetValueLensClass;
}
var ModifyValueLensClass;
function ModifyValueLens() {
  if (ModifyValueLensClass === VOID) {
    class $ extends ValueLens() {
      constructor(source, get, modify) {
        return new.target.new_com_lightningkite_reactive_lensing_ModifyValueLens_ce3zc7_k$(source, get, modify);
      }
      static new_com_lightningkite_reactive_lensing_ModifyValueLens_ce3zc7_k$(source, get, modify) {
        var $this = this.new_com_lightningkite_reactive_lensing_ValueLens_6349z_k$(source, get);
        $this.modify_1 = modify;
        return $this;
      }
      set_value_v1vabv_k$(value) {
        var transformed = this.modify_1(this.source_1.get_value_j01efc_k$(), value);
        super.set_value_jb4831_k$(this.get_1(transformed));
        this.source_1.set_value_v1vabv_k$(transformed);
      }
      set_value_jb4831_k$(value) {
        return this.set_value_v1vabv_k$(value);
      }
      get_value_j01efc_k$() {
        return super.get_value_j01efc_k$();
      }
    }
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).set_revjhg_k$ = set;
    protoOf($).lens_drj4fu_k$ = lens_1;
    protoOf($).lens_u4wb4z_k$ = lens_2;
    initMetadataForClass($, 'ModifyValueLens', VOID, VOID, [MutableReactiveValue()], [1]);
    ModifyValueLensClass = $;
  }
  return ModifyValueLensClass;
}
var ValueLensClass;
function ValueLens() {
  if (ValueLensClass === VOID) {
    class $ extends BaseReactiveValue() {
      constructor(source, get) {
        return new.target.new_com_lightningkite_reactive_lensing_ValueLens_6349z_k$(source, get);
      }
      static new_com_lightningkite_reactive_lensing_ValueLens_6349z_k$(source, get) {
        // Inline function 'kotlin.let' call
        var tmp$ret$0 = get(source.get_value_j01efc_k$());
        var $this = this.new_com_lightningkite_reactive_core_BaseReactiveValue_bwum4c_k$(tmp$ret$0);
        $this.source_1 = source;
        $this.get_1 = get;
        $this.myListen_1 = null;
        return $this;
      }
      set_value_jb4831_k$(value) {
        super.set_value_v1vabv_k$(value);
      }
      set_value_v1vabv_k$(value) {
        return this.set_value_jb4831_k$(value);
      }
      get_value_j01efc_k$() {
        if (this.myListen_1 == null) {
          var tmp0 = this.source_1.get_value_j01efc_k$();
          // Inline function 'kotlin.let' call
          var tmp$ret$0 = this.get_1(tmp0);
          super.set_value_v1vabv_k$(tmp$ret$0);
        }
        return super.get_value_j01efc_k$();
      }
      activate_yijg9v_k$() {
        super.activate_yijg9v_k$();
        var tmp = this;
        tmp.myListen_1 = this.source_1.addListener_6y9mct_k$(() => {
          var tmp0 = this.source_1.get_value_j01efc_k$();
          // Inline function 'kotlin.let' call
          var tmp$ret$0 = this.get_1(tmp0);
          super.set_value_v1vabv_k$(tmp$ret$0);
          return Unit_instance;
        });
        var tmp0 = this.source_1.get_value_j01efc_k$();
        // Inline function 'kotlin.let' call
        var tmp$ret$1 = this.get_1(tmp0);
        super.set_value_v1vabv_k$(tmp$ret$1);
      }
      deactivate_pmdz1g_k$() {
        super.deactivate_pmdz1g_k$();
        var tmp0_safe_receiver = this.myListen_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.myListen_1 = null;
      }
    }
    initMetadataForClass($, 'ValueLens');
    ValueLensClass = $;
  }
  return ValueLensClass;
}
function lens_3(_this__u8e3s4, get) {
  return Lens().new_com_lightningkite_reactive_lensing_Lens_wq5tr4_k$(_this__u8e3s4, get);
}
function lensListenable(_this__u8e3s4, get) {
  var tmp = new (lensListenable$1())(_this__u8e3s4);
  return ValueLens().new_com_lightningkite_reactive_lensing_ValueLens_6349z_k$(tmp, (it) => get());
}
function lens_4(_this__u8e3s4, get) {
  return ValueLens().new_com_lightningkite_reactive_lensing_ValueLens_6349z_k$(_this__u8e3s4, get);
}
var lensListenable$1Class;
function lensListenable$1() {
  if (lensListenable$1Class === VOID) {
    class $ {
      constructor($this_lensListenable) {
        this.$$delegate_0__1 = $this_lensListenable;
      }
      get_value_i5oc5k_k$() {
        return Unit_instance;
      }
      get_value_j01efc_k$() {
        this.get_value_i5oc5k_k$();
        return Unit_instance;
      }
      addListener_6y9mct_k$(listener) {
        return this.$$delegate_0__1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.$$delegate_0__1.beginUse_omrbby_k$();
      }
    }
    protoOf($).get_state_wc71uu_k$ = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [ReactiveValue(), Listenable()]);
    lensListenable$1Class = $;
  }
  return lensListenable$1Class;
}
//region block: exports
export {
  ModifyLens as ModifyLens104zsbx7gwa6e,
  ModifyValueLens as ModifyValueLenspp00mwqm1elc,
  SetLens as SetLens2527bvop19mpo,
  SetValueLens as SetValueLensuxj8ukufftbv,
  lensListenable as lensListenable3n4xxl63wcyqk,
  lens_4 as lens3m3nj3zkwtu6r,
  lens_3 as lens27v59dqa1oc3r,
};
//endregion

//# sourceMappingURL=abstracts.mjs.map
